import TCPADisclaimer from './TCPADisclaimer';
export default TCPADisclaimer;